import { Tooltip as MantineTooltip, TooltipProps } from "@mantine/core"

interface RingTooltipProps extends TooltipProps {}

export function Tooltip({ children, ...props }: RingTooltipProps) {
  return (
    <MantineTooltip
      withArrow
      position="bottom"
      openDelay={500}
      {...props}
      classNames={{
        tooltip: "!z-[1000]",
        ...props?.classNames,
      }}
    >
      {children}
    </MantineTooltip>
  )
}
